import OverviewEU from './VersionEU';
// import OverviewDE from './VersionDE';
import { useGlobal } from '@/utils/useGlobal';

export default function CollectionPC() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    return (
        <>
            {locale === 'eu' && <OverviewEU />}
            {locale === 'de' && <OverviewEU />}
            {locale === 'uk' && <OverviewEU />}
        </>
    );
}
